import '../../style/index.less';
import '../../grid/style/index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.9.2@antd/es/col/style/index.js
// module id = T1my
// module chunks = 0 1 3 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 34 35